import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { map, switchMap} from 'rxjs/operators';
import {OrdersService} from '../../order/services/orders.service';
import {debug} from '../../../rxjs-operators';
import {
  deviceAvailableActionTypes,
  LoadDeviceAvailableAction, LoadDeviceAvailableByClientAction,
  LoadDeviceAvailableFailAction,
  LoadDeviceAvailableSuccessAction
} from '../actions/device-available';
import {ArrayResponse, BaseEffect, error, SendBackResult} from '../index';
import {Device} from '../models/device';
import {Router} from '@angular/router';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class DeviceAvailableEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(ofType(deviceAvailableActionTypes.LOAD),
      debug('Devices load action received.'),
      map((action: LoadDeviceAvailableAction) => action.payload),
      switchMap((payload: number) => this.ordersService.getAvailableDevice(payload).pipe(
        map((resp: SendBackResult<ArrayResponse<Device>>) => new LoadDeviceAvailableSuccessAction(resp.data.array))))
  )});
  loadByClient$ = createEffect(() => { return this.actions$.pipe(ofType(deviceAvailableActionTypes.LOAD_BY_CLIENT),
    debug('Devices load action received.'),
    map((action: LoadDeviceAvailableByClientAction) => action.payload),
    switchMap((payload: {productID: number , client: string , order: string}) => this.ordersService.getAvailableDeviceByClientAndByOrder(payload).pipe(
      map((resp: SendBackResult<ArrayResponse<Device>>) => new LoadDeviceAvailableSuccessAction(resp.data.array))))
  )});

  loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(deviceAvailableActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving device list.'),
    map((action: LoadDeviceAvailableFailAction) =>
      error(this.translation.translate('DEVICE_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  protected handleUnhandledError = (response) => new LoadDeviceAvailableFailAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadDeviceAvailableFailAction(response['error'].message);
  }

  constructor(router: Router,
              private actions$: Actions,
              private translation: L10nTranslationService,
              private ordersService: OrdersService) {
  super(router);
  }
}
